export enum Filters {
  None = 0,
  Place = 1,
  Date = 2,
  Service = 3,
  Search = 4,
  Brand = 5,
}

export enum Organizations {
  REPAREO = 1,
  ARVAL = 2,
  DBCONNECT = 3,
  DEMO = 4,
  MOBILITYCONCEPT = 5,
  CONTROLEXPERT = 6,
  AYVENS = 7,
  ALPHABET = 8,
  SOLLOG = 9,
  FINN = 10,
  BERESA = 11,
  DEUTSCHELEASING = 12,
  FLEETHUB = 13,
  AKF = 14,
  DEUTSCHELEASINGBOSCH = 16,
  NIO = 20,
  AKFLANGZEITMIETE = 22,
  MEINAUTO = 24,
  GENERALMOTORS = 19,
  VEHICLEVER = 26,
  ASS = 28,
  MEHRMARKENCENTER = 18,
  BATTERY_QUICK_CHECK = 21,
  LIQUI_MOLY = 27,
  AUTOCREW = 29,
  ALD = 30,
  RESERVE_WITH_GOOGLE = 32,
  ATHLON = 31,
  SIGNALIDUNA = 35,
  SANTANDER = 36,
  ITZEHOER = 37,
  CPM = 38,
  RAIFFEISEN_IMPULS_DE = 39,
  MFS_OPAL = 48,
  MARA = 46,
  MOBILE_GARANTIE = 49,
  MFS = 42,
}

export enum Services {
  WHEELCHANGE = "1",
  APPOINTMENT = "2",
  WHEELREPLACEMENT = "7",
  OILCHANGE = "12",
  INSPECTION = "13",
  INSPECTIONANDWHEELCHANGE = "231",
  TIMINGBELT = "14",
  BRAKES = "15",
  GARAGESNEARBY = "19",
  GLASS = "34",
  AUTOABO = "93",
  VEHICLERETURN = "94",
  VEHICLEDELIVERY = "95",
  EVEHICLEAPPOINTMENT = "98",
  ELECTRONICLICENSECONTROL = "99",
  WHEELCHANGETIRESSTORED = "100",
  ADDITIONALTIRESERVICES = "106",
  CLUTCH = "118",
  CERTIFICATE = "132",
  AIRCONDITION = "136",
  TIRESTORAGE = "232",
  DAMAGE_DIAGNOSIS = "152",
  DAMAGE_REPAIR = "153",
  FLAT_TIRE_DRIVEABLE = "154",
}

export enum PremiumServices {
  COLLECTANDRETURN = 1,
  REPLACEMENTVEHICLE = 3,
  WHEELHUBCLEANING = 779,
  WHEELCHANGECARACTIVEPTMS = 788,
  WHEELASSEMBLYDISASSEMBLY = 789,
  STATIONARYBALANCING = 790,
  WHEELSETRETREIVAL = 791,
  ONETIREREPLACEMENT = 792,
  TWOTIREREPLACEMENT = 793,
  THREETIREREPLACEMENT = 794,
  FOURTIREREPLACEMENT = 795,
}

export enum PremiumServiceTypes {
  TYRECHANGEALREADYINSTORAGE = "TyreChangeAlreadyInStorage",
  COLLECT_AND_RETURN = "CollectAndReturn",
  UVV = "Uvv",
  TECHNICAL_REPAIR = "TechnicalRepair",
}

export enum Brands {
  TESLA = "89",
  MG = "60",
  MERCEDES = "59",
  POLESTAR = "70",
}

// The name of the internal_identifier from the GarageProperty
export enum GarageProperties {
  FREE_VEHICLE_RETURN = "free_vehicle_return",
}

export enum ErrorIds {
  ACTIVE_INQUIRY_EXISTS_FOR_NUMBER_PLATE = "active_inquiry_exists_for_number_plate",
  ACTIVE_INQUIRY_EXISTS_FOR_NUMBER_PLATE_AND_SERVICE = "active_inquiry_exists_for_number_plate_and_service",
  VEHICLE_NOT_FOUND_IN_EXTERNAL_FLEET = "vehicle_not_found_in_external_fleet",
  SLOT_ALREADY_BOOKED = "slot_already_booked",
  SLOT_ALREADY_BLOCKED = "slot_already_blocked",
  EARLIEST_RETURN_DATE_NOT_REACHED = "earliest_return_date_not_reached",
  NO_NUMBER_PLATE_FOUND = "no_number_plate_found",
  NO_DRIVER_FOUND_FOR_NUMBER_PLATE = "no_driver_found_for_number_plate",
  MEIN_AUTO_NO_TYRE_PRODUCT_IN_CUSTOMER_CONTRACT = "mein_auto_no_tyre_product_in_customer_contact",
  MEIN_AUTO_CUSTOMER_CONTRACT_NOT_FOUND = "mein_auto_customer_contact_not_found",
  CUSTOMER_ADDRESS = "customer_address",
}

export enum FormErrors {
  CONTRACT_NOT_FOUND = "contract_not_found",
  LASTNAME_NOT_FOUND = "lastname_not_found",
  DELIVERY_NOT_YET_POSSIBLE = "delivery_not_yet_possible",
  DELIVERY_WISH_ALREADY_SET = "delivery_wish_already_set",
  DELIVERY_WISH_NOT_SET = "delivery_wish_not_set",
}

export enum SortOrderType {
  EARLIEST_SLOT = "earliest_slot",
  SMALLEST_DISTANCE = "smallest_distance",
  CHEAPEST_PRICE = "cheapest_price",
  BEST_REVIEWED = "best_reviewed",
  RECOMMENDED = "recommended",
  PARTNER_RECOMMENDED = "partner_recommended",
  SHORTEST_TRAVEL_TIME = "shortest_travel_time",
}
